import { render, staticRenderFns } from "./GuestsModal.vue?vue&type=template&id=27a54b9e&scoped=true"
import script from "./GuestsModal.vue?vue&type=script&lang=js"
export * from "./GuestsModal.vue?vue&type=script&lang=js"
import style0 from "./GuestsModal.vue?vue&type=style&index=0&id=27a54b9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a54b9e",
  null
  
)

export default component.exports